import { html } from 'lit';
import { Lightbulb } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-lightbulb')
export class PdsIconLightbulb extends PdsIcon {
  @state()
  icon = Lightbulb;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
